// import axios from "axios"
import { propertyAPI } from "../../axios";

export const actions = {

    // Property Assignment
    GetPropertyAssignment(context, data){
        return propertyAPI.get(`PropertyAssignment/All/${data}`);
    },
    GetSinglePropertyAssignment(context, data){
        return propertyAPI.get(`PropertyAssignment/${data}`);
    },
    UpdatePropertyAssignment(context, data){
        return propertyAPI.put(`PropertyAssignment/${data.id}`, data);
    },
    DeletePropertyAssignment(context, data){
        return propertyAPI.delete(`PropertyAssignment/${data}`);
    },
    AddPropertyAssignment(context, data){
        return propertyAPI.post(`PropertyAssignment/Add`, data);
    },
    AddMultiplePropertyAssignment(context, data){
        return propertyAPI.post(`PropertyAssignment/Add/Multiple`, data);
    },
    ReturnPropertyAssignment(context, data){
        return propertyAPI.put(`PropertyAssignment/Return/${data.id}`, data);
    }, 
    ReturnMultiplePropertyAssignment(context, data){
        return propertyAPI.put(`PropertyAssignment/Return/Multiple`, data);
    },
    updateDateAssigned(context, data) {
        return propertyAPI.put(`PropertyAssignment/Update/Multiple/Date`, data);
    },
    updateLocation(context, data) {
        return propertyAPI.put(`PropertyAssignment/Update/Multiple/Locations`, data);
    },
    GetPendingReturnedPropertyAssignment(context, data){
        return propertyAPI.get(`PropertyAssignment/Returned/Pending/${data}`);
    },
    GetApprovedReturnedPropertyAssignment(context, data){
        return propertyAPI.get(`PropertyAssignment/Returned/Approved/${data}`);
    },
    ApproveReturnPropertyAssignment(context, data){
        return propertyAPI.put(`PropertyAssignment/Returned/Approve/${data}`);
    },
    ApproveReturnRequest(context, data){
        return propertyAPI.put(`PropertyAssignment/Returned/Approve/ReturnGroupId/${data}`);
    },
    UpdateMultiplePropertyStatus(context, data){
        return propertyAPI.post(`PropertyAssignment/Update/Multiple/PropertyStatus`, data);
    }
}